import BaseComponent from '@/components/base';
import Style from '@/components/accordion-advanced/accordion-body/style';

export default class AccordionBody extends BaseComponent {
  render() {
    return `
      ${Style}
      <section class="accordion-advanced-body">
        <slot></slot>
      </section>
    `;
  }
}
